import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  BulkFirmwareDeviceUpdateRequest,
  BulkFirmwareUpdateResponse,
  BulkStartFirmwareUpdateRequest,
  BulkStartFirmwareUpdateResponse,
  FirmwareCatalogueFilter,
  FirmwareDeviceUpdateRequest,
  FirmwareModel,
  StartFirmwareUpdateResponse,
} from '@core/models';

export const FirmwareActions = createActionGroup({
  source: 'Firmware',
  events: {
    'Get Firmware Versions': props<{ filter?: FirmwareCatalogueFilter }>(),
    'Get Firmware Versions Success': props<{ items: FirmwareModel[] }>(),
    'Get Firmware Versions Failure': props<{ error: unknown }>(),

    'Deactivate Firmware': props<{ firmwareId: number }>(),
    'Deactivate Firmware Success': props<{ firmwareId: number }>(),
    'Deactivate Firmware Failure': props<{ error: unknown }>(),

    'Update Device Firmware': props<{ request: FirmwareDeviceUpdateRequest }>(),
    'Update Device Firmware Success': emptyProps(),
    'Update Device Firmware Failure': props<{ error: unknown }>(),

    'Start Dlms Firmware Update': props<{ deviceId: string; firmwareId: number }>(),
    'Start Dlms Firmware Update Success': props<{ response: StartFirmwareUpdateResponse }>(),
    'Start Dlms Firmware Update Failure': props<{ error: unknown }>(),

    'Reset Update State': emptyProps(),

    'Bulk Update Device Firmware': props<{ request: BulkFirmwareDeviceUpdateRequest }>(),
    'Bulk Update Device Firmware Success': props<{ response: BulkFirmwareUpdateResponse }>(),
    'Bulk Update Device Firmware Failure': props<{ error: unknown }>(),

    'Bulk Start Dlms Firmware Update': props<{ request: BulkStartFirmwareUpdateRequest }>(),
    'Bulk Start Dlms Firmware Update Success': props<{
      response: BulkStartFirmwareUpdateResponse;
    }>(),
    'Bulk Start Dlms Firmware Update Failure': props<{ error: unknown }>(),

    'Update Bulk Progress': props<{
      deviceId: string;
      status: 'in_progress' | 'success' | 'failed';
    }>(),
    'Reset Bulk Update State': emptyProps(),
  },
});
